const KEYS = {
  title: ["property=\"og:title\"", "name=\"twitter:title\""],
  description: ["property=\"og:description\"", "name=\"twitter:description\""],
  image: ["property=\"og:image\"", "property=\"og:image:secure_url\"", "name=\"twitter:image\""],
  url: ["property=\"og:url\""],
  type: ["property=\"og:type\""],
};

// Rewrites the single set of OG/Twitter tags from index.html in place (no duplicates for crawlers).
export const applyOg = (values) => {
  const prev = [];
  Object.entries(values).forEach(([k, v]) => {
    if (!v) return;
    (KEYS[k] || []).forEach((sel) => {
      const el = document.head.querySelector(`meta[${sel}]`);
      if (!el) return;
      prev.push([el, el.getAttribute("content")]);
      el.setAttribute("content", v);
    });
  });
  return () => prev.reverse().forEach(([el, c]) => el.setAttribute("content", c));
};
